"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = exports.ModalAlert = exports.ModalConfirm = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var ModalMain_1 = require("./ModalMain");
var ModalConfirm_1 = require("./ModalConfirm");
Object.defineProperty(exports, "ModalConfirm", { enumerable: true, get: function () { return ModalConfirm_1.ModalConfirm; } });
var ModalAlert_1 = require("./ModalAlert");
Object.defineProperty(exports, "ModalAlert", { enumerable: true, get: function () { return ModalAlert_1.ModalAlert; } });
var ModalShow_1 = require("./ModalShow");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var event_1 = require("./event");
var noop_1 = require("../_util/noop");
exports.Modal = forward_ref_with_statics_1.forwardRefWithStatics(function (props, ref) { return (react_1.default.createElement(ModalMain_1.Modal, tslib_1.__assign({ ref: ref }, props))); }, {
    /**
     * 渲染对话框的主要内容
     */
    Body: ModalMain_1.Modal.Body,
    /**
     * 渲染对话框的底部内容
     */
    Footer: ModalMain_1.Modal.Footer,
    /**
     * 对话框消息内容，可置于 ModalMain..Body 中
     */
    Message: ModalMain_1.Modal.Message,
    /**
     * 全局配置
     */
    config: ModalMain_1.Modal.config,
    /**
     * API 的方式唤起一个确认对话框
     * @returns 异步返回布尔值，为 `true` 则表示用户确认，为 `false` 则表示用户取消
     */
    confirm: ModalConfirm_1.confirm,
    /**
     * API 的方式唤起一个对话框显示成功信息
     */
    success: ModalAlert_1.success,
    /**
     * API 的方式唤起一个对话框显示失败信息
     */
    error: ModalAlert_1.error,
    /**
     * API 的方式唤起一个对话框显示提醒信息
     */
    alert: ModalAlert_1.alert,
    /**
     * API 的方式唤起一个对话框
     */
    show: ModalShow_1.show,
    /**
     * 全局对话框开启回调
     */
    onOpen: function (listener) {
        if (listener === void 0) { listener = noop_1.noop; }
        event_1.modalEventEmitter.on("open", listener);
    },
    /**
     * 全局对话框关闭回调
     */
    onClose: function (listener) {
        if (listener === void 0) { listener = noop_1.noop; }
        event_1.modalEventEmitter.on("close", listener);
    },
});
exports.Modal.displayName = "Modal";
//# sourceMappingURL=Modal.js.map